import { render, staticRenderFns } from "./config-share.vue?vue&type=template&id=46abe2f9&"
import script from "./config-share.vue?vue&type=script&lang=js&"
export * from "./config-share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports